import React from "react";
import { useExternalEntities } from "../ExternalEntitiesProvider/ExternalEntitiesProvider";
import { TwoUIBasicProgressView, TwoUIProgressViewType } from "./TwoUIBasicProgressView/TwoUIBasicProgressView";

export const TwoUIProgressView: TwoUIProgressViewType = (props) => {
    const ProgressView = useExternalEntities().operationEntities?.ExternalProgressView ?? TwoUIBasicProgressView;
    return <ProgressView {...props} />;
};
